export interface Pagination<T = any> {
  items: T[];
  metaData: PaginationMetadata;
}

export interface PaginationMetadata {
  totalItems?: number;
  currentPage?: number;
  perPage?: number;
  firstPage?: number;
  lastPage?: number;
  nextPage?: number;
}

export interface PaginationRequestParams {
  page?: number;
  lang?: string;
  itemsPerPage?: number
}

export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc'
}
